import UserEdit from '../_form.js'

import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    UserEdit
  },
  data() {
    return {
      ready: false,
      data: {
        customerId: 0
      },
      errors: {},
      customerOptions: [],
      callCenterOptions: [],
      siteOptions: []
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('users.operators.form.edit.title'))
        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.users.operators.index'), route: {name: 'operators-index'}},
          {label: this.$t('breadcrumbs.users.operators.edit'), route: {}}
        ])
        this.getData()
        this.loadCustomers()
        this.loadCallCenters()
        this.loadSites()
      }
    }
  },
  methods: {
    t(key, options = {}) {
      return this.$t(`users.operators.edit.${key}`, options)
    },

    update(data) {
      this.errors = {}

      API.users.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('users.form.succesfullyEdit'))
        this.$router.push({name: 'operators-index'})
      }, errors => {
        this.errors = errors
      })
    },

    getData() {
      this.ready = false
      API.users.show(this.$route.params.id).then(response => {
        this.data = response
        this.ready = true
      })
    },

    loadSites() {
      API.sites.index(
        {page: {number: 1, size: 1000}, order: {name: 'asc'}}
      ).then(response => {
        this.siteOptions = response.data.map(site => ({
          label: site.description || site.url,
          value: site.id
        }))
      })
    },

    loadCallCenters() {
      API.callCenters.index(
        {page: {number: 1, size: 1000}, order: {name: 'asc'}}
      ).then(response => {
        this.callCenterOptions = response.data.map(customer => ({
          label: customer.name,
          value: customer.id
        }))
      })
    },

    loadCustomers() {
      API.customers.index(
        {page: {number: 1, size: 1000}, order: {name: 'asc'}}
      ).then(response => {
        this.customerOptions = response.data.map(customer => ({
          label: customer.name,
          value: customer.id
        }))
      })
    }
  }
})
